;(function () {
	const CardSlider = () => {
		const sections = document.querySelectorAll('.as-card-slider');
		if (!sections) return;

		sections.forEach(section => {
            const swiperEl = section.querySelector('.as-card-slider-swiper');
            if (swiperEl) {
                const isAutoplay = swiperEl.getAttribute('data-autoplay') === 'true';
                const speed = parseFloat(swiperEl.getAttribute('data-speed')) * 1000; 
                const delay = parseFloat(swiperEl.getAttribute('data-delay')) * 1000;
                const accordionEl = section.querySelector('.as-accordion-wrapper');
                const accordionItems = accordionEl.querySelectorAll('.as-accordion-item');
                let accordionActiveIndex = Array.from(accordionItems).find(item => item.classList.contains('active'))?.dataset.accordionIndex;

                const swiperConfig = {
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            centeredSlides: true,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 1,
                            centeredSlides: true,
                            spaceBetween: 1,
                        },
                    },
                    // slidesPerView: 1.23,
                    // centeredSlides: true,
                    // spaceBetween: 8,
                    observer: true,
                    observeParents: true,
                    observeSlideChildren: true,
                    loop: false,
                    speed: speed,
                    pagination: {
                        el: swiperEl.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: swiperEl.querySelector('.swiper-button-next') || null,
                        prevEl: swiperEl.querySelector('.swiper-button-prev') || null
                    },
                    on: {
                        slideChange: function (swiper) {
                            const activeIndex = swiper.activeIndex;
                            if (activeIndex === accordionActiveIndex) return;
                            accordionChange(activeIndex, false);
                        },
                        touchEnd: function (swiper) {
                            // 解决拖拽时swiper索引不变化问题
                            setTimeout(() => {
                                const currentIndex = swiperEl.querySelector('.swiper-slide-active').dataset.slideIndex;
                                if (currentIndex !== accordionActiveIndex) {
                                    accordionChange(currentIndex, true);
                                }
                            }, 50); 
                        }
                    }
                };

                if (isAutoplay) {
                    swiperConfig.autoplay = {
                        delay: delay,
                        disableOnInteraction: false,
                        waitForTransition: false,
                        pauseOnMouseEnter: false,
                    };
                }

                const swiperObj = new Swiper(swiperEl, swiperConfig);
                const accordionContainer = section.querySelector('.as-accordions-container');

                accordionEl.style.maxHeight = `${swiperEl.offsetHeight}px`;

                accordionItems.forEach((item) => {
                    item.addEventListener('click', () => {
                        const accordionIndex = Number(item.dataset.accordionIndex);
                        accordionChange(accordionIndex);
                    }); 
                });

                const accordionChange = (activeIndex, slideTo = true) => {
                    const activeItem = accordionItems[activeIndex];
                    const lastActiveItem = accordionItems[accordionActiveIndex];
                    if (activeItem === lastActiveItem) return;
                    lastActiveItem.classList.remove('active');
                    activeItem.classList.add('active');
                    accordionActiveIndex = activeIndex;
                    if (slideTo) {
                        swiperObj.slideTo(activeIndex);
                    }
                    
                    const rect = section.getBoundingClientRect();
                    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                    if (isVisible && accordionContainer) {
                        setTimeout(() => {
                            const itemTop = activeItem.offsetTop;
                            const itemBottom = itemTop + activeItem.offsetHeight;
                            const containerScrollTop = accordionContainer.scrollTop;
                            const containerHeight = accordionContainer.clientHeight;
                            
                            if (itemTop < containerScrollTop) {
                                accordionContainer.scrollTo({ top: itemTop, behavior: 'smooth' });
                            } else if (itemBottom > containerScrollTop + containerHeight) {
                                accordionContainer.scrollTo({ 
                                    top: itemBottom - containerHeight, 
                                    behavior: 'smooth' 
                                });
                            }
                        }, 400);
                    }
                }
            }
        });
	};

	document.addEventListener('DOMContentLoaded', function () {
		CardSlider();
		document.addEventListener('shopify:section:load', function () {
			CardSlider();
		});
	});
})();